module.exports = __webpack_public_path__ + "img/combination.549f1858.jpg";